import { Persona, Text } from "@fluentui/react-components";
import { useStyles } from "../../../../../styles/styleClasses";
import { mergeClasses } from "@fluentui/react-components";
import {
  LanguageStrings,
  useLocalization,
} from "../../../../../contexts/LocalizationContext";

function RecipientField(props: { recipient: string }) {
  const styles = useStyles();
  const localized = useLocalization() as LanguageStrings;

  return (
    <div className={styles.overflowHidden}>
      <div className={styles.pbXs}>
        <Text truncate className={styles.textNeutralForeground3}>
          {localized.Recipient}
        </Text>
      </div>
      <Persona
        className={mergeClasses(styles.persona, styles.dFlex)}
        size="extra-small"
        name={props.recipient}
        textAlignment="center"
      />
    </div>
  );
}

export default RecipientField;
